
      var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBin = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.417 7.333H5.583l1.412 12.495a.382.382 0 0 0 .38.339h9.232a.382.382 0 0 0 .38-.339l1.43-12.495z",
  fill: "transparant"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m14.334 10.25-.584 6.417M9.667 10.25l.583 6.417M5.583 7.333h12.834l-1.43 12.495a.382.382 0 0 1-.38.339H7.374a.382.382 0 0 1-.38-.34L5.585 7.334z",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.817 4.364v-.362c0-.703.57-1.273 1.273-1.273h3.818c.703 0 1.273.57 1.273 1.273v.362",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 1.6
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M5 7.333a.583.583 0 0 1-.583-.583V5.583c0-.322.26-.583.583-.583h14c.322 0 .583.261.583.583V6.75a.583.583 0 0 1-.583.583H5z",
  fill: "var(--theme-bright, #e3d2e9)",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 1.6,
  strokeLinejoin: "round"
})));

      const __svgRaw = "<svg width=\"25\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path d=\"M18.417 7.333H5.583l1.412 12.495a.382.382 0 0 0 .38.339h9.232a.382.382 0 0 0 .38-.339l1.43-12.495z\" fill=\"transparant\"/>\r\n    <path d=\"m14.334 10.25-.584 6.417M9.667 10.25l.583 6.417M5.583 7.333h12.834l-1.43 12.495a.382.382 0 0 1-.38.339H7.374a.382.382 0 0 1-.38-.34L5.585 7.334z\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n    <path d=\"M8.817 4.364v-.362c0-.703.57-1.273 1.273-1.273h3.818c.703 0 1.273.57 1.273 1.273v.362\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.6\"/>\r\n    <path d=\"M5 7.333a.583.583 0 0 1-.583-.583V5.583c0-.322.26-.583.583-.583h14c.322 0 .583.261.583.583V6.75a.583.583 0 0 1-.583.583H5z\" fill=\"var(--theme-bright, #e3d2e9)\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.6\" stroke-linejoin=\"round\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/bin.96591673f81aec5c3a736dd36a21d4fc.svg"),
        {
          React: SvgBin,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      